"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var RootRoute = /** @class */ (function (_super) {
    tslib_1.__extends(RootRoute, _super);
    function RootRoute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RootRoute, "propTypes", {
        get: function () {
            return {
                children: PropTypes.node,
                routeParams: PropTypes.object,
            };
        },
        enumerable: true,
        configurable: true
    });
    RootRoute.prototype.childRoutes = function () {
        var _this = this;
        return React.Children.map(this.props.children, function (child) {
            return React.cloneElement(child, { region: _this.props.routeParams.region });
        });
    };
    RootRoute.prototype.render = function () {
        return (React.createElement("div", null, this.childRoutes()));
    };
    return RootRoute;
}(React.Component));
exports.default = RootRoute;
//# sourceMappingURL=root_route.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/root_route.js
// module id = mmoV
// module chunks = 20 21